import * as React from 'react';
import { Sparkles } from 'lucide-react';
import { FieldLabel } from 'features/DigitalMarketing/components/FormControls';
import { editWebsiteContentLabelClassName } from 'features/DigitalMarketing/constants/formStyles';
import { DMButton, DMDiv, DMText, DMTextarea } from '../Primitives';

type DMAiDescriptionBoxProps = {
  label?: string;
  name?: string;
  value: string;
  placeholder?: string;
  required?: boolean;
  isGenerating: boolean;
  isGenerateDisabled?: boolean;
  generationsRemaining: number;
  generateButtonLabel?: string;
  generatingLabel?: string;
  className?: string;
  matchContainerHeight?: boolean;
  labelClassName?: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onGenerate: () => void;
};

export const DMAiDescriptionBox = ({
  label = 'Description',
  name = 'description',
  value,
  placeholder = 'Enter Description',
  required = false,
  isGenerating,
  isGenerateDisabled = false,
  generationsRemaining,
  generateButtonLabel = 'Generate with AI',
  generatingLabel = 'Generating...',
  className = 'h-[28vh]',
  matchContainerHeight = false,
  labelClassName,
  onChange,
  onGenerate,
}: DMAiDescriptionBoxProps) => (
  <DMDiv className={matchContainerHeight ? 'flex h-full flex-col' : ''}>
    <FieldLabel
      className={labelClassName || editWebsiteContentLabelClassName}
      required={required}
    >
      {label}
    </FieldLabel>
    <DMDiv
      className={`flex flex-col rounded-[10px] border border-gray-300 bg-white px-[1.1vw] py-[1.4vh] ${
        matchContainerHeight ? 'flex-1' : className
      }`}
    >
      <DMTextarea
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="min-h-0 flex-1 resize-none bg-transparent text-[1.95vh] font-medium leading-[1.4] text-gray-950 outline-none placeholder:text-gray-400"
      />
      <DMButton
        type="button"
        onClick={onGenerate}
        disabled={
          isGenerateDisabled || isGenerating || generationsRemaining <= 0
        }
        className="mx-auto mt-[1vh] flex h-[5.5vh] w-[22vw] items-center justify-center gap-[0.8vw] rounded-full bg-primary-main text-[1.75vh] font-semibold text-white disabled:opacity-60"
      >
        <Sparkles className="h-[2.1vh] w-[2.1vh]" strokeWidth={2} />
        <DMText as="span">
          {isGenerating ? generatingLabel : generateButtonLabel}
        </DMText>
      </DMButton>
    </DMDiv>
  </DMDiv>
);
